import { BridgeDatasource } from '@anduin/shared';
import { IServerSideGetRowsParams } from 'ag-grid-community';
import { OutboundEmailRow } from '../../../models';

// BridgeDatasource generic type is not being used, so I added unknown type
export class EmailDeliveryHubDataSourceService extends BridgeDatasource<OutboundEmailRow> {
  getRows(params: IServerSideGetRowsParams): void {
    const agGridAutoGroup = params.request?.sortModel?.findIndex((each) => each.colId === 'ag-Grid-AutoColumn');

    if (agGridAutoGroup !== undefined && agGridAutoGroup !== -1) {
      params.request.sortModel[agGridAutoGroup].colId = 'sentAt';
    }

    const parentKeys = params.request.groupKeys || [];

    if (parentKeys.length === 0) {
      return super.getRows(params);
    }

    const data = params.parentNode.data;
    const recipients = params.parentNode.data.recipientDetails;

    return params.success({
      rowData: recipients.map((each) => ({
        ...data,
        ...each,
        recipients: each.recipient,
        hasChildren: false,
        level: 1,
      })),
      rowCount: recipients.length,
    });
  }
}
